import router from './router'
import accordMessages from './localization'

export default {
  router,
  localization: accordMessages,
}
